import React from 'react';
import { useSpring, animated } from 'react-spring';

interface ZoomControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onZoomReset: () => void;
  onFitToScreen: () => void;
  minZoom?: number;
  maxZoom?: number;
}

const ZoomControls: React.FC<ZoomControlsProps> = ({
  zoom,
  onZoomIn,
  onZoomOut,
  onZoomReset,
  onFitToScreen,
  minZoom = 0.1,
  maxZoom = 3
}) => {
  const canZoomIn = zoom < maxZoom;
  const canZoomOut = zoom > minZoom;

  // Animation for the controls
  const springProps = useSpring({
    from: { opacity: 0, transform: 'translateY(10px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 300, friction: 25 }
  });

  return (
    <animated.div style={springProps} className="zoom-controls">
      <div className="zoom-controls-container">
        <button
          onClick={onZoomIn}
          disabled={!canZoomIn}
          className="zoom-button"
          title="Zoom In (Ctrl/Cmd + +)"
        >
          <span className="zoom-icon">+</span>
        </button>

        <div className="zoom-display" onClick={onZoomReset} title="Click to reset to 100%">
          {Math.round(zoom * 100)}%
        </div>

        <button
          onClick={onZoomOut}
          disabled={!canZoomOut}
          className="zoom-button"
          title="Zoom Out (Ctrl/Cmd + -)"
        >
          <span className="zoom-icon">−</span>
        </button>

        <div className="zoom-divider" />

        <button
          onClick={onFitToScreen}
          className="zoom-button zoom-fit"
          title="Fit to Screen (Ctrl/Cmd + 0)"
        >
          <span className="zoom-icon">⌂</span>
        </button>
      </div>
    </animated.div>
  );
};

export default ZoomControls;